export enum ApplicationTypeFilter {
  All = 'ALL',
  DirectCredit = 'DC',
  InternationalCredit = 'ICC',
  PRA = 'PRA',
}
